import { render, staticRenderFns } from "./AdminSegnalazioneSelezionata.vue?vue&type=template&id=d1ccb7d2&scoped=true&lang=pug&"
import script from "./AdminSegnalazioneSelezionata.vue?vue&type=script&lang=ts&"
export * from "./AdminSegnalazioneSelezionata.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSegnalazioneSelezionata.vue?vue&type=style&index=0&id=d1ccb7d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1ccb7d2",
  null
  
)

export default component.exports